// recordingNoticeAck.ts — CORE-1920
//
// Отметка «предупреждение о записи подтверждено» на устройстве: ставит экран
// входа, читает комната (recordingNoticeGate.ts). Сбой хранилища не ломает
// вход: незаписанная отметка — это лишний показ экрана, а не закрытая комната.

import { storage } from '../../../utils/storage';
import { hasRecordingAck, recordingAckIdentity, withRecordingAck } from './recordingNoticeGate';

export async function rememberRecordingAck(
  userId: string | null | undefined,
  room: { id?: number | string | null; inviteCode?: string | null },
): Promise<void> {
  try {
    const stored = await storage.getLiveRecordingAcks();
    await storage.setLiveRecordingAcks(withRecordingAck(stored, recordingAckIdentity(userId), room));
  } catch { /* не фатально: экран покажется ещё раз */ }
}

export async function readRecordingAck(
  userId: string | null | undefined,
  roomRefs: ReadonlyArray<number | string | null | undefined>,
): Promise<boolean> {
  const stored = await storage.getLiveRecordingAcks().catch(() => [] as string[]);
  return hasRecordingAck(stored, recordingAckIdentity(userId), roomRefs);
}
